import { VehicleType } from "./vehicle-type";

export class VehicleGroup {
    id!: string;
    groupTitle? : string;
    vehicleTypeName!: string;
    quantity!: number;
    capacityType1?: number;
    capacityType2?: number;
    capacityType3?: number;
    planId!: string;
    tenantId!: string;
    vehicleTypeId!: number;
    imgPath?: string;
    vehicleType!: VehicleType;
}